function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-navigation-cancel-24-px_svg__a",
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm4.3 14.3a.996.996 0 01-1.41 0L12 13.41 9.11 16.3a.996.996 0 11-1.41-1.41L10.59 12 7.7 9.11A.996.996 0 119.11 7.7L12 10.59l2.89-2.89a.996.996 0 111.41 1.41L13.41 12l2.89 2.89c.38.38.38 1.02 0 1.41z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "icon-navigation-cancel-24-px_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#icon-navigation-cancel-24-px_svg__a"
})), React.createElement("g", {
  fill: "#000",
  fillOpacity: 0.54,
  mask: "url(#icon-navigation-cancel-24-px_svg__b)"
}, React.createElement("path", {
  d: "M0 0h24v24H0z"
})));

var SvgIconNavigationCancel24Px = function SvgIconNavigationCancel24Px(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref, _ref2);
};

export default SvgIconNavigationCancel24Px;